import React, { useEffect } from 'react';

function CalendlyModal({ isOpen, onClose }) {
    useEffect(() => {
        if (isOpen) {
            // Cargar el script de Calendly cuando se abre el modal
            const script = document.createElement('script');
            script.src = 'https://assets.calendly.com/assets/external/widget.js';
            script.async = true;
            document.body.appendChild(script);

            return () => {
                // Limpiar el script cuando se cierre el modal
                document.body.removeChild(script);
            };
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                padding: '20px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '16px',
                    width: '100%',
                    maxWidth: '1000px',
                    height: '90vh',
                    maxHeight: '700px',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Botón de cerrar */}
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#001C4D',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '24px',
                        fontWeight: 'bold',
                        zIndex: 10000,
                        transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#002a5c';
                        e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#001C4D';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    ×
                </button>

                {/* Widget de Calendly */}
                <div
                    className="calendly-inline-widget"
                    data-url="https://calendly.com/admin-solver-app/30min"
                    style={{
                        width: '100%',
                        height: '100%',
                        minHeight: '100%'
                    }}
                />
            </div>
        </div>
    );
}

export default CalendlyModal;
